// frontend enums for display
export enum PayeeDisplayStatusTypes {
  Pending = "Pending review",
  Approved = "Approved",
  Rejected = "Returned",
  Unknown = "Unknown",
}
